import { useTranslation } from 'react-i18next';

import { IconButton, IconPositionEnum, Variant } from '@indicia/component-library';
import useBem from '@indicia/use-bem';

import Icon from '../../../../shared/components/button/enums/Icon';
import SurveyQuestionType from '../../../../shared/models/survey/SurveyQuestionType';
import useSurveyContext from '../../store/UseSurveyContext';

import './SurveyNavigation.scss';

type PropType = {
  onHandleNext: () => void;
  onHandlePrevious: () => void;
  onHandleFinish: () => void;
  nextDisabled: boolean;
  firstQuestion: boolean;
  lastQuestion: boolean;
};

const SurveyNavigation = ({
  onHandleNext,
  onHandlePrevious,
  onHandleFinish,
  nextDisabled,
  firstQuestion,
  lastQuestion,
}: PropType) => {
  const { DEV_MODE } = window.__RUNTIME_CONFIG__;

  const { bemClassName, bemClassNames } = useBem('survey-navigation');
  const { t } = useTranslation();
  const { setAllAnswers, question } = useSurveyContext();
  const { questionType, title } = question || {};

  let label = t('survey.next');

  if (questionType === SurveyQuestionType.CHAPTER_INTRODUCTION) {
    label = t('survey.next-chapter', { chapter: title.toLowerCase() });
  }

  if (lastQuestion) {
    label = t('survey.submit');
  }

  return (
    <div className="content-container">
      <div className={bemClassName()}>
        {DEV_MODE === 'true' && (
          <div className={bemClassName('dev')}>
            <IconButton
              onClick={setAllAnswers}
              iconName={Icon.arrowRight}
              iconWidth={16}
              iconHeight={16}
            >
              Set all answers
            </IconButton>
          </div>
        )}
        <div className={bemClassNames([bemClassName('content'), bemClassName('content', 'single', firstQuestion)])}>
          {!firstQuestion && (
            <IconButton
              onClick={onHandlePrevious}
              iconName={Icon.arrowLeft}
              iconPosition={IconPositionEnum.Left}
              iconWidth={16}
              iconHeight={16}
              id={`${question?.questionId}-previous`}
              variant={Variant.Outlined}
            >
              {t('survey.back')}
            </IconButton>
          )}
          <IconButton
            onClick={lastQuestion ? onHandleFinish : onHandleNext}
            iconName={Icon.arrowRight}
            iconWidth={16}
            iconHeight={16}
            disabled={nextDisabled}
            id={`${question?.questionId}-next`}
          >
            {label}
          </IconButton>
        </div>
      </div>
    </div>
  );
};

export default SurveyNavigation;
